<div class="row">
  <div class="col-12">
    <div class="row">
      <div class="col-12">
        <div class="graphHeader">
          <div class="row">
            <div class="col-2 leftAllign">
              <div class="graphHeaderTitle">{{headerTitle}}</div>
            </div>
            <div class="col-10 rightAllign">
              <ul class="buttonsList">
                <li class="linksButtons customSelectGraph">
                  <span>
                    <img class="graphButtonImage"
                      [src]="'/assets/menu/'+ _theme +'/selectGraphButton-show-top-10-icon.svg'" />
                    </span>
                    <kendo-combobox class="selectGraphButton"
                      [data]="_showData"
                      [placeholder]="'Show Top 10'"
                      textField="field"
                      valueField="value"
                      (valueChange)="_showDataValueChange($event)">
                    </kendo-combobox>
                  </li>
                  <li class="linksButtons customSelectGraph">
                    <span>
                      <img class="graphButtonImage"
                        [src]="'/assets/menu/'+ _theme +'/selectGraphButton-select-graph-icon.svg'" />
                      </span>
                      <kendo-combobox class="selectGraphButton"
                        [placeholder]="'Select Graph'"
                        [data]="templatesName"
                        (valueChange)="_selectGraphByTempalateName($event)">
                      </kendo-combobox>
                    </li>
                    <li class="linksButtons">
                      <span>
                        <img class="imageAdd" [src]="'/assets/menu/'+ _theme +'/selectGraphButton-add-new-graph-icon.svg'" />
                      </span>
                      Add New Graph
                    </li>
                    <li class="linksButtons">
                      <span>
                        <img class="imageAdd" [src]="'/assets/menu/'+ _theme +'/selectGraphButton-edit-graph-icon.svg'" />
                      </span>
                      <ng-container>Edit Graph</ng-container>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <p class="fullScreenGraphButton" (click)="_openSliderForm()">
              <img [src]="'/assets/menu/'+ _theme +'/view-graph-icon.svg'" />
              Open in seperate window
            </p>
          </div>
        </div>
      </div>
    </div>

    @if (_active) {
      <kendo-window (close)="_closeForm()">
        <apx-chart [series]="apexValue.series"
          [chart]="apexValue.chart"
          [plotOptions]="apexValue.plotOptions"
          [dataLabels]="apexValue.dataLabels"
          [stroke]="apexValue.stroke"
          [xaxis]="apexValue.xaxis"
          [yaxis]="apexValue.yaxis"
          [fill]="apexValue.fill"
        [title]="apexValue.title"></apx-chart>
      </kendo-window>
    }
